var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { RadioButtonStyles } from './RadioButtonStyles';
import { ParagraphBody } from '../../paragraphs';
export var RadioButton = function (_a) {
    var label = _a.label, value = _a.value, _b = _a.dataCy, dataCy = _b === void 0 ? 'radio-button' : _b, handleRadioClick = _a.handleRadioClick, selected = _a.selected, _c = _a.tabFocusTrap, tabFocusTrap = _c === void 0 ? 0 : _c;
    var _d = useState(false), focused = _d[0], setFocused = _d[1];
    var _e = useState(0), tabIndex = _e[0], setTabIndex = _e[1];
    useEffect(function () {
        setTabIndex(tabFocusTrap);
    }, [tabFocusTrap]);
    useEffect(function () {
        setTabIndex(selected !== value && selected !== undefined ? -1 : 0);
    }, [selected]);
    var handleChecked = function () {
        if (selected !== value) {
            handleRadioClick(value, label);
        }
    };
    return (_jsx(RadioButtonStyles, __assign({ focused: focused }, { children: _jsxs("div", __assign({ id: label.replaceAll(' ', '-'), className: "radio-button-container", onClick: function () { return handleChecked(); } }, { children: [_jsx("div", __assign({ className: "radio-button-check-container" }, { children: _jsx("div", __assign({ className: "radio-button" }, { children: _jsx("div", { className: selected === value ? 'radio-button-selected' : '' }) })) })), _jsx(ParagraphBody, __assign({ className: "radio-text" }, { children: label })), _jsx("input", { type: "radio", checked: selected === value, defaultChecked: selected === value, onBlur: function () { return setFocused(false); }, onFocus: function () { return setFocused(true); }, "data-cy": dataCy, onChange: function () { }, "aria-labelledby": label.replaceAll(' ', '-'), tabIndex: tabIndex })] })) })));
};
